import AppLayout from 'v2/containers/ProjectDetail/AppLayout/AppLayout';
import React, { useEffect } from 'react';
import { IRouteV2 } from 'data';
import routes from './projectDetailRoutes';
import './ProjectDetail.scss';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectProject } from 'v2/store/projectDetail/actions/SelectProject';

const ProjectDetail: React.FC = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    dispatch(selectProject(projectId));
  }, [dispatch, projectId]);

  return <AppLayout routes={routes as IRouteV2[]} />;
};

export default ProjectDetail;
